// extracted by mini-css-extract-plugin
module.exports = {"landingTitle":"Landing_landingTitle__272Hb","role":"Landing_role__2BCaQ","yesBtn":"Landing_yesBtn__7Keku"};